export function ChartGoingUp(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.0938 16.5H1.96875V0.375C1.96875 0.167812 1.80094 0 1.59375 0H0.84375C0.636562 0 0.46875 0.167812 0.46875 0.375V17.25C0.46875 17.6644 0.804375 18 1.21875 18H24.0938C24.3009 18 24.4688 17.8322 24.4688 17.625V16.875C24.4688 16.6678 24.3009 16.5 24.0938 16.5ZM5.07844 9.32953C4.93219 9.47578 4.93219 9.71344 5.07844 9.85969L5.60859 10.3898C5.75484 10.5361 5.9925 10.5361 6.13875 10.3898L9.54609 7.01437L13.5159 10.9842C13.8089 11.2772 14.2838 11.2772 14.5767 10.9842L18.9609 6.6L21.0253 8.66438C21.2573 8.89641 21.5423 9 21.8222 9C22.4072 9 22.9688 8.54531 22.9688 7.85906V2.25891C22.9688 1.83984 22.6289 1.5 22.2098 1.5H16.6097C15.5953 1.5 15.0877 2.72625 15.8048 3.44344L17.9006 5.53922L14.0466 9.39328L10.0795 5.42625C9.7875 5.13422 9.31453 5.13328 9.02156 5.42391L5.07844 9.32953ZM17.4825 3H21.4688V6.98625L17.4825 3Z"
        fill="black"
      />
    </svg>
  );
}
